<!--
 * @Author: zhangweinan
 * @Date: 2023-11-08 14:34:40
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-09-14 16:06:56
 * @Description: file content
 * @FilePath: \manage_property\src\components\element\grid.vue
-->
<script lang="jsx">
import { onMounted, ref, watch, nextTick, onUnmounted } from 'vue';
export default {
  name: 'EGrid',
  props: {
    columns: {
      //列声明数组 ，详细请参考element-plus table组件中Table-column 属性的文档说明
      type: Array,
      required: true,
    },
    loading: {
      //是否加载中
      type: Boolean,
    },
    pagination: {
      //为el-pagination组件的属性，详细请参考element-plus Pagination组件中相应的文档说明
      type: Object,
      default: () => {
        return {};
      },
    },
    height: {
      type: String,
      default: 'calc(100% - 42px)',
    }
  },
  setup(props, ctx) {
    let cloumns = props.columns.map(e => {
      if (e.render) {
        return <el-table-column {...e} v-slots={e.render && { default: e.render }} />;
      } else {
        return <el-table-column {...e} />;
      }
    });
    const height = ref(props.height);
    const table = ref(null);
    const grid = ref(null);
    const resizeHeight = () => {
      nextTick(() => {
        if (grid.value) {
          height.value = (grid.value.offsetHeight - 42) + 'px';
        }
      });
    };
    watch(() => props.height, (val) => {
      height.value = val;
    })
    onMounted(() => {
      resizeHeight();
    });
    window.addEventListener('resize', resizeHeight);
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHeight);
    });
    return () => (
      <div ref={grid} class="Grid" vLoading={props.loading}>
        {/*  */}
        <el-table ref={table} class="table" {...ctx.attrs} height={height.value}>
          {cloumns}
        </el-table>
        {props.pagination ? (
          <div class="pagination-box">
            <el-pagination {...props.pagination} />
          </div>
        ) : null}
      </div>
    );
  },
  methods: {
    toggleRowSelection() {
      this.$refs.table.toggleRowSelection(...arguments);
    },
  },
};
</script>
<style lang="scss" scoped>
.Grid {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: space-between;
  height: 100%;

  /* ::v-deep {

    .el-table__inner-wrapper {
      height: 100%;
    }

    .el-table__body-wrapper,
    .el-scrollbar__wrap {
      max-height: calc(100% - 40px);
    }
  } */

  ::v-deep {
    .el-table {
      border: 1px solid #E3E5E8;
      border-bottom: none;
    }

    .el-table th.el-table__cell {
      background-color: #F1F2F4;
    }

    .el-table__inner-wrapper {
      height: 100% !important;
    }
  }
}

.pagination-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;

  /* .el-pagination {
    margin-right: -5px;
  } */
}
</style>
